import type { YourRentalRewardsSectionDto } from '@zg-rentals/ts-your-rental-api-client';
import { RewardsApiUserStatus } from '@zg-rentals/ts-your-rental-api-client';
import RewardsUpsellCard from './RewardsUpsellCard';
import RewardsSummaryCard from './RewardsSummaryCard';

type RewardsCardProps = {
  rewardsSection: YourRentalRewardsSectionDto;
  autoOpenEnroll?: boolean;
};

function getMaxPoints(progressSteps?: Array<string>): number {
  if (!progressSteps || progressSteps.length === 0) return 0;
  return parseInt(progressSteps[progressSteps.length - 1], 10) || 0;
}

export default function RewardsCard({ rewardsSection, autoOpenEnroll }: RewardsCardProps) {
  const { rewardsCard, user, isEnabled, isSupported } = rewardsSection;

  if (!isEnabled || !isSupported || !rewardsCard) {
    return null;
  }

  const isActive = user?.status === RewardsApiUserStatus.ACTIVE;

  if (isActive && user) {
    return (
      <RewardsSummaryCard
        rewardsCard={rewardsCard}
        user={user}
        maxPoints={getMaxPoints(user.presentation?.progressSteps)}
      />
    );
  }

  return (
    <RewardsUpsellCard
      rewardsCard={rewardsCard}
      bonusOffers={user?.presentation?.bonusOffers}
      autoOpenEnroll={autoOpenEnroll}
    />
  );
}
